<template>
  <div id="app-footer">
    <div class="copyright">仪征市图书馆技术部维护 Copyright © {{startYear}} <span v-if="currYear > startYear">-{{currYear}}</span> </div>
    <div class="footer-image"></div>

  </div>
</template>

<script>
export default {
  name: 'Footer',
  data(){
    return {
      startYear: 2020,
      currYear: new Date().getFullYear()
    }
  }

}
</script>

<style scoped>
#app-footer{
  width:100%;
  height:310px;
  padding-top:20px;
  background: url('../assets/index_bg.png') repeat;
  background-size: 100% 100%;
}
.copyright{
  text-align: center;
  font-size: 14px;
  font-family: "Microsoft Yahei";
  color:#ffffff;
}

.footer-image{
  width: 100%;
  height:268px;
  background: url('../assets/footer-bg.png') no-repeat;
  background-size: 100% 100%;
  position: relative;
  bottom: 0px;
}
</style>